/**
 * @file コンポーネント：ページング DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import {
    StyledPagination,
    StyledPaginationAnchor,
    StyledPaginationCurrent,
    StyledPaginationInactive,
    StyledPaginationList,
    StyledPaginationListItem,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledPagination>
            <StyledPaginationList>
                {props.currentIndex > 2 && (
                    // currentが3ページ目以降の場合
                    <>
                        <StyledPaginationListItem>
                            <StyledPaginationAnchor
                                data-font-size={props.fontSize}
                                data-on-color={props.onColor}
                                href={props.list[0].href}
                                onClick={props.list[0].onClick}
                                title={localized["Label.FirstPage"]}
                            >
                                <i className="fas fa-angle-double-left"></i>
                            </StyledPaginationAnchor>
                        </StyledPaginationListItem>
                        <StyledPaginationListItem>
                            <StyledPaginationInactive
                                data-font-size={props.fontSize}
                                data-on-color={props.onColor}
                            >
                                <i className="fas fa-ellipsis-h"></i>
                            </StyledPaginationInactive>
                        </StyledPaginationListItem>
                    </>
                )}
                {props.list.map(
                    (item, index) =>
                        Math.abs(props.currentIndex - index) < 3 && (
                            // currentの前後の2ページ以内のみ出力
                            <StyledPaginationListItem key={"page-" + index}>
                                {item.isCurrent ? (
                                    // 現在のページ
                                    <StyledPaginationCurrent
                                        data-font-size={props.fontSize}
                                        data-on-color={props.onColor}
                                    >
                                        {(index + 1).toLocaleString()}
                                    </StyledPaginationCurrent>
                                ) : (
                                    // それ以外
                                    <StyledPaginationAnchor
                                        data-font-size={props.fontSize}
                                        data-on-color={props.onColor}
                                        href={item.href}
                                        onClick={item.onClick}
                                    >
                                        {(index + 1).toLocaleString()}
                                    </StyledPaginationAnchor>
                                )}
                            </StyledPaginationListItem>
                        )
                )}
                {props.list.length - 1 > props.currentIndex + 2 && (
                    // 最後のページがcurrentより3ページ以上後の場合
                    <>
                        <StyledPaginationListItem>
                            <StyledPaginationInactive
                                data-font-size={props.fontSize}
                                data-on-color={props.onColor}
                            >
                                <i className="fas fa-ellipsis-h"></i>
                            </StyledPaginationInactive>
                        </StyledPaginationListItem>
                        <StyledPaginationListItem>
                            <StyledPaginationAnchor
                                data-font-size={props.fontSize}
                                data-on-color={props.onColor}
                                href={props.list[props.list.length - 1].href}
                                onClick={
                                    props.list[props.list.length - 1].onClick
                                }
                                title={localized["Label.LastPage"]}
                            >
                                <i className="fas fa-angle-double-right"></i>
                            </StyledPaginationAnchor>
                        </StyledPaginationListItem>
                    </>
                )}
            </StyledPaginationList>
        </StyledPagination>
    );
};
